module.exports = __webpack_public_path__ + "static/media/29170013-min.4ac2e4aa.jpg";